import { render, staticRenderFns } from "./product-cards-list.vue?vue&type=template&id=a7a7f484&scoped=true&"
import script from "./product-cards-list.vue?vue&type=script&lang=js&"
export * from "./product-cards-list.vue?vue&type=script&lang=js&"
import style0 from "./product-cards-list.vue?vue&type=style&index=0&id=a7a7f484&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a7f484",
  null
  
)

export default component.exports